import { LoaderButton } from '../../generic/Button';
import Text from '../../generic/Text';
import AuthForm from '../form';
import CenteredLayout from '../layouts/Centered';

type AccessPendingProps = {
  orgTitle: string;
  isLoading: boolean;
  onCancelAccessRequest: () => void;
};

/**
 * Message displayed to users when they have requested access to an org.
 *
 * @param {string} orgTitle - Title of the organization the user is trying to join.
 * @param {string} isLoading - State of network requests, so we can show the loader.
 * @param {string} onCancelAccessRequest - Function called which will cancel the user's access request.
 */
const AccessPending = ({
  orgTitle,
  isLoading,
  onCancelAccessRequest,
}: AccessPendingProps) => (
  <main className="fossa-auth">
    <CenteredLayout>
      <AuthForm.Container onSubmit={onCancelAccessRequest}>
        <AuthForm.Heading heading="Hang Tight!" />
        <div className="margin-top-xl margin-bottom-xl">
          <Text>
            We&apos;re waiting for someone from {orgTitle} to approve your access request. You&apos;ll get an email once you can start using FOSSA.
          </Text>
        </div>
        <LoaderButton
          type="error"
          size="small"
          isDisabled={isLoading}
          isLoading={isLoading}
          onClick={onCancelAccessRequest}
          isFullWidth
        >
          Cancel Access Request
        </LoaderButton>
      </AuthForm.Container>
    </CenteredLayout>
  </main>
);

export default AccessPending;
